import { Service } from '@tino-frontend/adapters'
import { VerifyOtpPayload, SignInVerifyOtpResponse } from '@types'

export class SignInService {
  private path = '/sign-in'

  constructor(private readonly http: Service) {}

  sendOtp(phone: string) {
    return this.http.post(`/v1${this.path}/whatsapp/otp`, {
      phone: `+${phone}`,
    })
  }

  async verifyOtp(payload: VerifyOtpPayload): Promise<SignInVerifyOtpResponse> {
    return this.http.post(`/v1${this.path}/whatsapp/otp/verify`, {
      ...payload,
      phone: `+${payload.phone}`,
    })
  }
}
